import React from 'react';
import { Trophy, Star, Sparkles } from 'lucide-react';

const MilestoneHeader = ({ milestone }) => {
  const is10 = milestone === 10;

  return (
    <div className="text-center mb-8">
      {/* Badge */}
      <div className={`inline-flex items-center justify-center w-28 h-28 rounded-full mb-6 shadow-2xl ${
        is10
          ? 'bg-gradient-to-br from-purple-500 to-indigo-600' :'bg-gradient-to-br from-indigo-500 to-blue-600'
      }`}>
        {is10 ? (
          <Trophy className="w-14 h-14 text-white" />
        ) : (
          <Star className="w-14 h-14 text-white" />
        )}
      </div>

      {/* Milestone badge */}
      <div className={`inline-flex items-center gap-2 px-4 py-1.5 rounded-full text-sm font-bold mb-4 ${
        is10
          ? 'bg-purple-100 text-purple-800' :'bg-indigo-100 text-indigo-800'
      }`}>
        <Sparkles className="w-4 h-4" />
        {is10 ? 'Milestone 2 Achieved — 10 Referrals!' : 'Milestone 1 Achieved — 5 Referrals!'}
      </div>

      {/* Title */}
      <h1 className={`text-3xl sm:text-4xl font-extrabold mb-3 leading-tight ${
        is10 ? 'text-purple-900' : 'text-indigo-900'
      }`}>
        {is10
          ? "You've unlocked Full Premium Access!" :"You've unlocked Doctor Consultation Summary!"}
      </h1>

      <p className="text-gray-600 text-lg max-w-md mx-auto">
        {is10
          ? 'Thank you for growing the MyBodyToday community. All Premium features are now permanently yours — free.'
          : 'Your referrals have earned you access to the Doctor Consultation Summary report — completely free.'}
      </p>
    </div>
  );
};

export default MilestoneHeader;
